/**
 * @param {array} statistics - statistics array
 */
export const getCountUserStatistics = (statistics) => {
  return (
    (statistics &&
      statistics.reduce(
        (currentState, statistic) => {
          if (statistic.date_due) {
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            const currentDay = currentDate.getDate();
            const currentDayOfTheWeek = currentDate.getDay();
            const currentMonth = currentDate.getMonth();

            const statisticDate = new Date(statistic.date_due);
            statisticDate.setHours(0, 0, 0, 0);
            const statisticDay = statisticDate.getDate();
            const statisticDayOfTheWeek = statisticDate.getDay();
            const statisticMonth = statisticDate.getMonth();

            if (
              statisticDay === currentDay &&
              statisticDayOfTheWeek === currentDayOfTheWeek &&
              statisticMonth === currentMonth
            ) {
              if (statistic.annotated)
                currentState.daily += statistic.annotated;
            }

            if (
              statisticDay - statisticDayOfTheWeek ===
                currentDay - currentDayOfTheWeek &&
              statisticMonth === currentMonth
            ) {
              if (statistic.annotated)
                currentState.weekly += statistic.annotated;
            }

            if (currentMonth === statisticMonth) {
              if (statistic.annotated)
                currentState.monthly += statistic.annotated;
            }
          }

          return currentState;
        },
        { daily: 0, weekly: 0, monthly: 0 }
      )) || {
      daily: 0,
      weekly: 0,
      monthly: 0,
    }
  );
};
